export default __webpack_public_path__ + "static/media/ic_admins.cc70a6f7.svg";